import React, { useState, useEffect } from "react";
import { css } from "styled-components";
import throttle from "lodash/throttle";
import { Spacing } from "../helpers/layout";
import { Button } from "./Button";
import { MODAL_LEVEL } from "../helpers/zIndex";
import Router from "next/router";

export function OpenSeries(props: { slug: string }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = throttle(() => {
      const el = document.documentElement;
      const clientHeight = el.clientHeight;
      const scrollTop = document.body.scrollTop || el.scrollTop;
      const reachedPoint = scrollTop > clientHeight * 0.3;

      if (reachedPoint) {
        setShow(true);
      } else {
        setShow(false);
      }
    }, 200);

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      css={css`
        position: sticky;
        bottom: -150px;
        padding: ${Spacing.xxl} 0;
        padding-bottom: calc(${Spacing.xxl} + ${Spacing.xl});
        text-align: center;
        z-index: ${MODAL_LEVEL - 1};
        transition: bottom 300ms;

        /* Keep the floating button 2rem above the viewport edge: the sticky
           offset hides all bottom padding beyond that. */
        ${show &&
        css`
          bottom: -${Spacing.xxl};
        `}
      `}
    >
      <div
        css={css`
          position: relative;
          top: 7px;
        `}
      >
        <Button
          type="button"
          label="See the complete series"
          onClick={() => {
            Router.push("/series/[slug]/shop", `/series/${props.slug}/shop`);
          }}
        />
      </div>
    </div>
  );
}
